import {payoffChart, PayoffChart} from "./element/TradingIdeasPayoffChartComponent";

import Charts from "./charts";

export default function(parentDir: string): string {
    const rootDir = `${parentDir}/payoff`;

    return angular.module("tfApp.trading-ideas.elements.payoff", [Charts(rootDir)])
                  .component(PayoffChart, payoffChart(rootDir))
                  .name;
}
